/** @file memoryFetchBytes: the runtime's FetchBytes over in-memory bundle files under a base URL. */
import type { FetchBytes } from '@zilo/pose3d-runtime-babylon/bundle/fetchBytes';

/**
 * `url` = `base` + bundle path; text files are UTF-8 encoded. A URL outside `base` or a missing file rejects
 * (the loader turns that into `BUNDLE_FETCH`).
 */
export function memoryFetchBytes(files: Readonly<Record<string, Uint8Array | string>>, base: string): FetchBytes {
  const encoder = new TextEncoder();
  return (url) => {
    const path = url.startsWith(base) ? url.slice(base.length) : null;
    const content = path !== null && Object.hasOwn(files, path) ? files[path] : undefined;
    if (content === undefined) return Promise.reject(new Error(`not in the preview bundle: ${url}`));
    return Promise.resolve(typeof content === 'string' ? encoder.encode(content) : content);
  };
}
